import { dateFilter } from '@/filters/date';

export const orderStatusName = function(status) {
	let statusName = '';
	switch (status) {
		case 'Waiting delivery':
		statusName = "Waiting delivery";
		break;
		case 'Awaiting Payment':
		statusName = "Awaiting Payment";
		break;
		case 'Canceled':
		statusName = "Canceled";
		break;
		case 'On delivery':
		statusName = "On delivery";
		break;
		case 'In operation':
		statusName = "In operation";
		break;

	}
	return statusName
};

export const default_img = function(path) {
	return path ? path + '?x-oss-process=image/resize,w_500,h_500,color_FFFFFF' : require('@/assets/images/default.jpg')
}

export const default_avatar = function(path) {
	return path ? path : require('@/assets/images/default-black.jpg')
}

export const get_sex = function(type) {
	switch (Number(type)) {
		case 0: return 'Unlimited';
		case 1: return "Men's style";
		case 2: return "Women's style";
	}
}

export const sex_filter = function(type){
	switch (Number(type)) {
		case 0: return 'Unlimited';
		case 1: return 'Male';
		case 2: return 'Female';
	}
}

export const sex_filter2 = function(type){
	switch (type) {
		case "": return 'Unlimited';
		case "男": return 'Male';
		case "女": return 'Female';
		case '不限': return 'Unisex';
		case '儿童': return 'Kids';
	}
}

export const diff_filter = function(type){
	switch (type) {
		case "": return '';
		case "简单款": return 'Simple';
		case "复杂款": return 'Complex';
	}
}

export const price_format = (value) => {
	return value ? (Math.round(value * 100) / 100).toFixed(2) : 0
}

export const duration_text = (datetime) => {
	let txt = datetime
	let d = new Date(datetime)
	let duration = Math.ceil((Date.now() - d.getTime()) / 1000)
	const isEn = true;
	if (duration < 60) {
		txt = isEn ? 'Just now' : '刚刚';
	  } else if (duration < 3600) {
		const mins = Math.floor(duration / 60);
		txt = isEn ? `${mins} minute${mins > 1 ? 's' : ''} ago` : `${mins}分钟前`;
	  } else if (duration < 86400) {
		const hours = Math.floor(duration / 3600);
		txt = isEn ? `${hours} hour${hours > 1 ? 's' : ''} ago` : `${hours}小时前`;
	  } else if (duration < 86400 * 7) {
		const days = Math.floor(duration / 86400);
		txt = isEn ? `${days} day${days > 1 ? 's' : ''} ago` : `${days}天前`;
	  } else {
		txt = isEn ? dateFilter.enDateNoTime(datetime) : dateFilter.default(datetime, 'YYYY年MM月DD日');
	  }

	return txt
}
export const EnTimeFilter = (time)=>{

}

export const plainText = (text)=>{
	if (!text) return '';
	const div = document.createElement('div');
	div.innerHTML = text;
	return div.textContent || div.innerText || '';
}

export const numberFormat = (value)=>{
	if (!value) return '0';

	// 处理小数点和千位分隔符
	const num = parseFloat(value);
	if (isNaN(num)) return '0';

	// 如果是百万级以上
	if (Math.abs(num) >= 1000000) {
		return (num / 1000000).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'M';
	}
	// 如果是千级以上
	else if (Math.abs(num) >= 1000) {
		return (num / 1000).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'K';
	}
	// 普通数字格式化，添加千位分隔符
	else {
		return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
}
